import { CertificationIcon } from 'foundations-assets/icons/components/CertificationIcon';
import { DiamondIcon } from 'foundations-assets/icons/components/DiamondIcon';
import { FavoriteHollowIcon } from 'foundations-assets/icons/components/FavoriteHollowIcon';
import { TrophyIcon } from 'foundations-assets/icons/components/TrophyIcon';
import unescapedText from 'I18n/utils/unescapedText';
import {
  DefaultTierPointsCreditedTierOption,
  ListingCard,
} from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';

/**
 * @returns `undefined` if `listing` is not a partner
 * @returns `partnerTier` if it exists, otherwise `'none'`
 */
export function getPartnerTier(listing: ListingCard) {
  const product = listing.products[0];

  if (product?.productType !== 'SOLUTIONS_PARTNER_PROFILE') return undefined;

  return product.partnerTier ?? 'none';
}

export function getPartnerTierContent(
  tier: DefaultTierPointsCreditedTierOption | undefined
) {
  switch (tier) {
    case 'elite':
      return {
        badgeUse: 'lorax' as const,
        icon: TrophyIcon,
        iconColor: undefined,
        text: unescapedText('marketplace-embed.card.partnerTiers.elite'),
      };
    case 'diamond':
      return {
        badgeUse: 'blue' as const,
        icon: DiamondIcon,
        iconColor: undefined,
        text: unescapedText('marketplace-embed.card.partnerTiers.diamond'),
      };
    case 'platinum':
      return {
        badgeUse: 'koala' as const,
        icon: CertificationIcon,
        iconColor: 'fill-accent-blue-default' as const,
        text: unescapedText('marketplace-embed.card.partnerTiers.platinum'),
      };
    case 'gold':
      return {
        badgeUse: 'koala' as const,
        icon: FavoriteHollowIcon,
        iconColor: undefined,
        text: unescapedText('marketplace-embed.card.partnerTiers.gold'),
      };
    default:
      return undefined;
  }
}
